import React, { useContext } from 'react';
import { PageContext } from '@/context/PageContext';
import { Metadata } from '@latitude/metadata';
import { AccordionFaqSidebar } from '@latitude/accordion-rebrand';
import Section from '@latitude/section-rebrand';
import { SITE_URL } from '@/utils/constants';

import Layout from '@/components/layout';
import LowRateMicrositeHeader from './_low-rate-header-rebrand';
import FaqHero from './faqHero';
import PageData from './data/low-rate-data.json';

const faqData = PageData.faqs.map(group => ({
  groupName: group.title,
  groupData: group.qa.map(item => ({
    title: item.q,
    content: item.a
  }))
}));

const Faqs = ({ location }) => {
  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};
  /** - END - */
  return (
    <Layout location={location} hasSecNav>
      <main
        className="navigation-spacer"
        css={`
          margin-top: 130px !important;
          background-color: #f8f8f8;
          .microsite-header {
            z-index: 2000 !important;
          }

          div[class^='MicrositeHeader__SecondBar'].microsite-header__nav-wrap {
            margin-top: 8px;
          }
          div[class^='MicrositeHeader__HeaderPlaceholder'] {
            height: auto;
          }
        `}
      >
        <Metadata
          title={`Low Rate FAQs | Low Rate Mastercard`}
          description={`Learn all the handy hints, tips, and answers for everything you wanted to know about your Low rate Card`}
          keywords="FAQ"
          canonical={`${SITE_URL}${location.pathname}`}
        />

        <LowRateMicrositeHeader applyNowUrl='/credit-cards/low-rate#limited-time-offer-selector'/>
        <FaqHero />

        <Section css={`padding: 48px 20px;`}>
          <AccordionFaqSidebar data={faqData} />
        </Section>
      </main>
    </Layout>
  );
};

export default Faqs;
